$(() => {
    $.validator.messages.number = "Hetta er ikki eitt gildugt heil tal";
    $.validator.messages.email = "Vinaliga skriva ein galdandi teldupost";


    let monthOfBirthCollapseBtn = <HTMLButtonElement>document.getElementById("triggerMonthCollapseBtn");
    let monthOfBirthCollapse = <HTMLDivElement>document.getElementById("MonthOfBirthCollapseId");
    let yearSelected = document.getElementById("Patient_YearOfBirth");



    let formValidtor = $("#submitFormId").validate();

    let currentYear = new Date().getFullYear();

    $("#Patient_YearOfBirth").change(event => {
        $("#submitFormId").validate().element("#Patient_YearOfBirth");

        let current = event.currentTarget as HTMLSelectElement;
        let selected = current.selectedOptions[0] as HTMLOptionElement;

        HandleMonthOfBirthCollapse(selected);
    });

    function HandleMonthOfBirthCollapse(selected: HTMLOptionElement) {
        let selectedYear = Number.parseInt(selected.value);
        let selectedGender = $('#Patient_Gender option:selected').text();
        if (!selectedYear) return;

        if (currentYear - 2 < selectedYear && !monthOfBirthCollapse.classList.contains("show")) {
            monthOfBirthCollapseBtn.click();
        } else if (currentYear - 2 >= selectedYear && monthOfBirthCollapse.classList.contains("show")) {
            monthOfBirthCollapseBtn.click();
        }
        if (currentYear - 15 < selectedYear) {
            $('#lengthOfPregnancy').hide();
        }
        if (currentYear - 15 > selectedYear && selectedGender !== "Kallkyn") {
            $('#lengthOfPregnancy').show();
        }
    }

    monthOfBirthCollapse.addEventListener('shown.bs.collapse', function () {
        let monthOfBirth = <HTMLSelectElement>document.getElementById('Patient.YearOfBirth');
        let selected = monthOfBirth.selectedOptions[0] as HTMLOptionElement;

        HandleMonthOfBirthCollapse(selected);
    });

    $("#Announcer_JobTitle").change(function (event) {
        $("#submitFormId").validate().element("#Announcer_JobTitle");

        let current = event.currentTarget as HTMLSelectElement;
        let selected = current.selectedOptions[0] as HTMLOptionElement;
    });


    $("#Patient_Gender").change(function () {
        $("#submitFormId").validate().element("#Patient_Gender");
        let selectedGender = $('#Patient_Gender option:selected').text();

        $("#submitFormId").validate().element("#Patient_Gender");
        if (selectedGender === "Kallkyn") {
            $('#lengthOfPregnancy').hide();
            $('#lengthOfPregnancy').val('0');
            $(".weight").removeClass("show");
        }
        else {
            $('#lengthOfPregnancy').show();
            $('#lengthOfPregnancy').prop('disabled', false);
            $(".weight").addClass("show");
        }
    });
});





$<HTMLSelectElement>("#YearOfBirth").change((event) => {

    var currentTime = new Date()
    let year = currentTime.getFullYear()
    let current = event.currentTarget as HTMLSelectElement;
    let toNumber = Number(current.value)
   
    if (toNumber <= year - 2) {
        
        $(".is2years").attr("checked", "checked");
        $(".collapse").removeClass("show");

    }
    else {
        
        $(".collapse").addClass("show");
        
        $(".not2years").prop("checked", true);


    }
});
